<template>
    <div class="row justify-content-center no-gutters">
        <div class="col col-md-9">
            <div class="system-settings-widget"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TradingTab'
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/Tabs/Trading.vue